import { render, staticRenderFns } from "./ResourceModal.vue?vue&type=template&id=d2cdc048&scoped=true&"
import script from "./ResourceModal.vue?vue&type=script&lang=js&"
export * from "./ResourceModal.vue?vue&type=script&lang=js&"
import style0 from "./ResourceModal.vue?vue&type=style&index=0&id=d2cdc048&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d2cdc048",
  null
  
)

export default component.exports

/* chakra-loader */
const installChakraComponents = require("!../../../../node_modules/chakra-loader/lib/install-components.js")
installChakraComponents(component, {CBox: require('@chakra-ui/vue').CBox, CModalBody: require('@chakra-ui/vue').CModalBody, CModalContent: require('@chakra-ui/vue').CModalContent, CModalOverlay: require('@chakra-ui/vue').CModalOverlay, CModal: require('@chakra-ui/vue').CModal})
